import { useContext } from 'react';
import ScreenerAppContext from './screener-app-context';

const useScreenerAppContext = () => {
  const context = useContext(ScreenerAppContext);
  if (!context) {
    console.warn('No Screener app context provided'); // eslint-disable-line no-console
  }

  return context;
};

export default useScreenerAppContext;
